<template>
  <div id="homeAmap">
    <el-amap
      ref="map"
      vid="amapDemo"
      :center="center || [116.39747, 39.90923]"
      :amap-manager="amapManager"
      :zoom="zoom"
      :mapStyle="mapStyle"
      :rotation="rotation"
      :viewMode="viewMode"
      :events="mapEvents"
    >
      <el-amap-marker
        v-for="(marker, index) in markers"
        :key="index"
        :position="marker.position"
        :content="marker.content"
        :events="marker.events"
      ></el-amap-marker>

      <el-amap-info-window
        v-if="infoWindow.visible"
        :position="infoWindow.position"
        :isCustom="true"
        :offset="[50, -30]"
        :closeWhenClickMap="true"
        :autoMove="true"
        :events="infoWindowEvents"
      >
        <div
          class="cardMain"
          :class="[
            infoWindow.data.deviceCurrent && infoWindow.data.deviceCurrent.alarmFlag == '1'
              ? 'cardAlarm'
              : ''
          ]"
        >
          <i
            class="iconfont iconpointing"
            :style="
              infoWindow.data.deviceCurrent && infoWindow.data.deviceCurrent.alarmFlag == '1'
                ? alarm
                : normal
            "
          ></i>
          <div class="topTitle">
            <h3>{{ infoWindow.data.deviceName }}-{{ infoWindow.data.device.address }}</h3>
            <h4>
              <span
                v-if="
                  infoWindow.data.deviceCurrent && infoWindow.data.deviceCurrent.alarmFlag == '1'
                "
                :style="
                  infoWindow.data.deviceCurrent && infoWindow.data.deviceCurrent.alarmFlag == '1'
                    ? alarm
                    : normal
                "
                >报警
              </span>
              <span v-else>无报警</span>
            </h4>
            <span class="lb"></span>
            <span class="rb"></span>
          </div>
          <div class="chartContent">
            <ul class="text">
              <li class="one">
                <div>
                  <span>传感器编号：</span>
                  <span>{{ infoWindow.data.device.device_mark }}</span>
                </div>
              </li>
              <li>
                <div>
                  <span>采样器时间：</span>
                  <span>{{
                    infoWindow.data.deviceCurrent
                      ? infoWindow.data.deviceCurrent.modify_time
                      : '--:--'
                  }}</span>
                </div>
              </li>
              <li class="two">
                <div v-if="dataInfo.length > 0">
                  <div class="prev" v-if="dataInfo.length > 5">
                    <i class="iconfont iconleft" @click="prev"></i>
                  </div>
                  <div class="next" v-if="dataInfo.length > 5">
                    <i class="iconfont iconright" @click="next"></i>
                  </div>
                  <div class="view">
                    <div :style="{ transform: `translateX(-${100 * (page - 1)}%)` }">
                      <ul :key="'ul' + i" v-for="i in Math.ceil(dataInfo.length / 5)">
                        <li
                          class="active"
                          v-for="(o, index) in dataInfo.slice((i - 1) * 5, i * 5)"
                          :key="index"
                        >
                          <div class="name">{{ o.dataflowName }}</div>
                          <div class="value">{{ o.dataflowData | filterValue }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="sc" v-else>
                  <span>暂无数据</span>
                </div>
              </li>
              <li class="three">
                <div>
                  <i
                    class="iconfont iconyuanquan"
                    :style="statusInfo && statusInfo.statusDesc == '在线' ? without : warning"
                  ></i>
                  <p>
                    设备{{ statusInfo && statusInfo.statusDesc ? statusInfo.statusDesc : '暂无' }}
                  </p>
                  <span class="lts"></span>
                  <span class="rts"></span>
                  <span class="lbs"></span>
                  <span class="rbs"></span>
                </div>
                <div
                  :style="{
                    color: '#fff',
                    background: '#09667B',
                    cursor: 'pointer'
                  }"
                  @click="infoWindow.visible = false"
                >
                  <p>确 定</p>
                  <span class="lts"></span>
                  <span class="rts"></span>
                  <span class="lbs"></span>
                  <span class="rbs"></span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-amap-info-window>
    </el-amap>
  </div>
</template>

<script>
  import { AMapManager } from 'vue-amap'
  let amapManager = new AMapManager()
  let _this
  export default {
    props: {
      areaData: {
        type: Object
      }
    },
    watch: {
      areaData: {
        handler(val) {
          _this = this
          this.getAreaData(val)
          this.getDictInfo()
        },
        deep: true,
        immediate: true
      }
    },
    data() {
      const self = this
      return {
        self,
        map: {},
        active: 0,
        timer: null,
        resizeEnable: true,
        mapStyle: 'amap://styles/9c80c60325eb32e163e5c55de4e5bae8',
        rotation: 20,
        zoom: 12,
        viewMode: '3D',
        pitch: 10,
        areaList: [],
        amapManager,
        markerRefs: [], // 存储 marker 实例
        clusterer: null, // 存储聚合实例
        mapEvents: {
          init(o) {
            // 地图初始化
            self.mapInstance = o
          },
          // 地图平移开始时关闭 infoWindow
          movestart() {
            self.infoWindow.visible = false
          },
          // 开始缩放时关闭 infoWindow
          zoomstart() {
            self.infoWindow.visible = false
          },
          dragstart() {
            self.infoWindow.visible = false
          }
        },
        stationList: [],
        markers: [],
        center: [116.397428, 39.90923],
        areaInfo: {},
        infoWindow: {
          visible: false,
          position: [0, 0],
          data: {}
        },
        infoWindowEvents: {
          close: () => {
            this.infoWindow.visible = false
          }
        },
        alarm: {
          color: '#ff4747'
        },
        normal: {
          color: '#35b9f7'
        },
        warning: {
          color: '#e48e49'
        },
        without: {
          color: '#42e594'
        },
        page: 1,
        dataFlowData: []
      }
    },
    computed: {
      statusInfo() {
        let b = this.infoWindow.data.deviceCurrent
        if (b && b.statusInfo) {
          let a = b.statusInfo
          if (a) {
            let deviceStatus = JSON.parse(a)
            return deviceStatus
          }
        }
      },
      dataInfo() {
        let b = this.infoWindow.data.deviceCurrent
        if (b && b.dataInfo) {
          if (
            this.infoWindow.data.device &&
            this.infoWindow.data.device.factory == 'ZGX-ZY-SBKZG'
          ) {
            return JSON.parse(b.dataInfo).splice(0, Number(this.infoWindow.data.device.model))
          } else {
            return JSON.parse(b.dataInfo)
          }
        } else {
          return []
        }
      }
    },
    methods: {
      getDictInfo() {
        this.$axiosget('operation/dictionaryType/queryByKey', {
          params: {
            key: 'pumpControlStatus'
          }
        }).then(res => {
          if (res.data.status === '10000') {
            this.dataFlowData = res.data.data ? res.data.data.list : []
          }
        })
      },
      getAreaData(val) {
        this.$axiosget('operation/automatic/hand/detection/getDeviceDataByArea', {
          params: {
            areaId: val.area.id
          }
        }).then(res => {
          if (res.data.status == 10000) {
            this.center = [val.area.longitude, val.area.latitude]
            this.stationList = res.data.data.map(item => {
              return {
                ...item,
                lnglat: [item.area.longitude, item.area.latitude],
                name: item.area.name,
                deviceName: item.device.deviceName,
                statusName:
                  item.deviceCurrent && item.deviceCurrent.statusInfo
                    ? JSON.stringify(item.deviceCurrent.statusInfo).statusDesc
                    : ''
              }
            })
            this.initMarkers()
          }
        })
      },
      initMarkers() {
        let self = this
        this.markers = this.stationList.map(item => {
          const isOffline = item.statusName === '离线'
          const bgColor = isOffline ? 'hsla(0, 0%, 60%, 0.7)' : 'hsla(120, 100%, 50%, 0.7)'
          const borderColor = isOffline ? 'hsl(0, 0%, 50%)' : 'hsl(120, 100%, 40%)'
          const shadowColor = isOffline ? 'hsl(0, 0%, 60%)' : 'hsl(120, 100%, 50%)'
          return {
            position: [item.lnglat[0], item.lnglat[1]],
            content: `<div style="min-width: 200px; width:auto; display: flex; align-items:center; color:#fff">
                <span style="display:inline-block;text-align:center; background-color: ${bgColor}; height: 12px; width: 12px; border: 1px solid ${borderColor}; border-radius: 100%; box-shadow: ${shadowColor} 0px 0px 1px; color:#fff; margin-right: 5px;"></span><div style="white-space: nowrap;">${item.deviceName}</div>
              </div>`,
            events: {
              init(o) {
                self.markerRefs.push(o)
              },
              click() {
                self.showInfoWindow(item)
              }
            }
          }
        })

        this.$nextTick(() => {
          // 数据、Marker 渲染完再初始化聚合
          this.initClusterer()
        })
      },

      showInfoWindow(item) {
        this.infoWindow.position = item.lnglat
        this.infoWindow.data = item
        this.infoWindow.visible = true
      },

      prev() {
        if (this.page == 1) return
        this.page--
      },
      next() {
        if (this.page == Math.ceil(this.dataInfo.length / 5)) return
        this.page++
      },

      initClusterer() {
        if (this.markerRefs.length === 0) return

        // 如果已经存在则清除
        if (this.clusterer) {
          this.clusterer.setMap(null)
        }

        // 确保 AMap 插件已加载
        if (AMap && AMap.MarkerClusterer) {
          this.clusterer = new AMap.MarkerClusterer(this.mapInstance, this.markerRefs, {
            gridSize: 80,
            renderClusterMarker: context => {
              this._renderClusterMarker(context)
            }
          })
        } else {
          console.error('AMap.MarkerClusterer 插件未加载，请检查 main.js 配置')
        }
      },

      _renderClusterMarker(context) {
        // 这里会被调用了
        const count = this.stationList.length // 总数
        let factor = Math.pow(context.count / count, 1 / 18)
        let div = document.createElement('div')
        let Hue = 180 - factor * 180
        let bgColor = 'hsla(' + Hue + ',100%,50%,0.7)'
        let fontColor = '#fff'
        let borderColor = 'hsla(' + Hue + ',100%,40%,1)'
        let shadowColor = 'hsla(' + Hue + ',100%,50%,1)'
        div.style.backgroundColor = bgColor
        let size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20)
        div.style.width = div.style.height = size + 'px'
        div.style.border = 'solid 1px ' + borderColor
        div.style.borderRadius = size / 2 + 'px'
        div.style.boxShadow = '0 0 1px ' + shadowColor
        div.innerHTML = context.count
        div.style.lineHeight = size + 'px'
        div.style.color = fontColor
        div.style.fontSize = '14px'
        div.style.textAlign = 'center'
        context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2))
        context.marker.setContent(div)
      }
    },
    filters: {
      filterValue(val) {
        let data = _this.dataFlowData.find(item => item.value == val).name
        return data
      }
    }
  }
</script>

<style lang="less" scoped>
  #homeAmap {
    padding-top: 9vh;
    height: 100%;

    /deep/ .cardMain {
      background: #001d3f;
      width: 387px;
      height: 215px;
      outline: 2px solid #323d55;
      position: relative;
      transform-origin: top left;

      &.cardAlarm {
        outline-color: #ff4747;
      }

      .iconpointing {
        position: absolute;
        top: -1px;
        right: -1px;
        font-size: 20px;
      }

      .topTitle {
        height: 18%;
        width: 97%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #464958;
        position: relative;

        .lb {
          position: absolute;
          left: 0;
          bottom: -1px;
          background-color: #35b9f7;
          width: 9px;
          height: 1px;
        }

        .rb {
          background-color: #35b9f7;
          width: 9px;
          height: 1px;
          position: absolute;
          right: 0;
          bottom: -1px;
        }

        h3 {
          font-size: 14px;
          color: #fff;
          font-weight: 100;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 8;
        }

        h4 {
          font-size: 12px;
          color: #35b9f7;
          flex: 2;
          text-align: right;
        }
      }

      .chartContent {
        width: 100%;
        height: 75%;
        margin: 4px auto 0;
        border-top: 1px solid #8c8e97;
        position: relative;

        .text {
          float: left;
          height: 100%;
          width: 100%;

          & > li {
            width: 100%;
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #fff;
            padding-left: 10px;
          }

          .one {
            padding-left: 10px;
            height: 20%;
          }

          .two {
            height: 42%;
            margin-top: 10px;
            padding: 0 20px;
            position: relative;

            & > div {
              width: 100%;
              height: 100%;
            }

            .prev,
            .next {
              width: 22px;
              height: auto;
              text-align: center;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;

              i {
                color: #939fb7;
                font-size: 12px;
              }
            }

            .prev {
              left: 0;
            }

            .next {
              right: 0;
            }

            .view {
              width: 100%;
              height: 100%;
              overflow: hidden;

              & > div {
                display: flex;
                height: 100%;
                transition-duration: 0.5s;
              }

              ul {
                width: 100%;
                height: 100%;
                flex-shrink: 0;
                display: flex;
                overflow: hidden;
                flex-wrap: nowrap;
                overflow: visible;

                li {
                  width: calc(20% - 6.4px);
                  cursor: pointer;
                  margin-right: 8px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  border: 1px solid #1991ca;

                  &:nth-child(5n) {
                    margin-right: 0;
                  }

                  .name {
                    font-size: 12px;
                    color: #fff;
                  }

                  .value {
                    font-size: 16px;
                    color: #29f4ff;
                  }
                }
              }
            }
          }

          .sc {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.6);
          }

          .three {
            height: 30%;
            padding: 0 10px;
            display: flex;
            justify-content: space-between;
          }

          .three {
            div {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 1%;
              width: 25%;
              height: 60%;
              outline: 1px solid #212740;
              position: relative;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: default;
            }

            i {
              font-size: 14px;
              display: block;
              margin-right: 5px;
            }

            span {
              display: block;
              width: 2px;
              height: 2px;
              background: #42e594;
              position: absolute;
            }

            .lbs {
              left: 0px;
              bottom: 0px;
            }
            .rbs {
              right: 0px;
              bottom: 0px;
            }

            .lts {
              left: 0px;
              top: 0px;
            }

            .rts {
              right: 0px;
              top: 0px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/amap/index.vue